import * as React from 'react';

const Label = ({text, asterisk = false}) =>
    <div className="custom-input">
        <label>{text} {asterisk && <span className="asterisk">*</span>}</label>
    </div>
;

export default Label;